import React, { useEffect, useCallback, useState } from "react";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";
import TaskTemplatesList from "../../components/maintenance/TaskTemplatesList";
import { STARTING_PAGE } from "../../constants/constants";
import {
  fetchTaskTemplates,
  fetchTaskTemplatesSuccess,
  fetchTaskTemplatesFailure,
  deleteTaskTemplate,
  deleteTaskTemplateSuccess,
  deleteTaskTemplateFailure,
} from "../../store/maintenance/actions";

const TaskTemplatesListContainer = ({
  taskTemplates,
  fetchTaskTemplates,
  deleteTaskTemplate,
}) => {
  const [currentPage, setCurrentPage] = useState(STARTING_PAGE);
  const [filters, setFilters] = useState({
    search: "",
    taskType: "",
    targetType: "",
    frequency: "",
    isActive: "",
  });

  useEffect(() => {
    fetchTaskTemplates(STARTING_PAGE);
  }, [fetchTaskTemplates]);

  const handleFilter = useCallback(
    (newFilters) => {
      setFilters(newFilters);
      setCurrentPage(STARTING_PAGE);
      fetchTaskTemplates(
        STARTING_PAGE,
        newFilters.taskType || null,
        newFilters.targetType || null,
        newFilters.frequency || null,
        newFilters.isActive === "" ? null : newFilters.isActive === "true",
        newFilters.search || null
      );
    },
    [fetchTaskTemplates]
  );

  const handlePageRequest = useCallback(
    (data) => {
      const page = data.selected + 1;
      if (page !== currentPage) {
        setCurrentPage(page);
        fetchTaskTemplates(
          page,
          filters.taskType || null,
          filters.targetType || null,
          filters.frequency || null,
          filters.isActive === "" ? null : filters.isActive === "true",
          filters.search || null
        );
      }
    },
    [currentPage, filters, fetchTaskTemplates]
  );

  const handleDelete = useCallback(
    async (id) => {
      try {
        await deleteTaskTemplate(id);
        fetchTaskTemplates(currentPage);
      } catch (err) {
        console.error("Error deleting template:", err);
      }
    },
    [deleteTaskTemplate, fetchTaskTemplates, currentPage]
  );

  return (
    <>
      <TaskTemplatesList
        templates={taskTemplates.list}
        loading={taskTemplates.loading}
        error={taskTemplates.error}
        onFilter={handleFilter}
        onDelete={handleDelete}
      />
      {taskTemplates.pages > 1 && (
        <ReactPaginate
          pageCount={taskTemplates.pages}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          previousLabel="<"
          nextLabel=">"
          onPageChange={handlePageRequest}
          initialPage={currentPage - 1}
          disableInitialCallback={true}
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="page-item active"
          previousClassName="paginate_button previous"
          nextClassName="paginate_button next"
          disabledClassName="page-item disabled"
          forcePage={currentPage - 1}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  taskTemplates: state.maintenance.taskTemplates,
});

const mapDispatchToProps = (dispatch) => ({
  fetchTaskTemplates: (page, taskType, targetType, frequency, isActive, search) => {
    dispatch(fetchTaskTemplates(page, taskType, targetType, frequency, isActive, search)).payload.then(
      (response) => {
        dispatch(fetchTaskTemplatesSuccess(response.data));
      },
      (error) => {
        dispatch(fetchTaskTemplatesFailure(error.response?.data || error));
      }
    );
  },
  deleteTaskTemplate: (id) => {
    return dispatch(deleteTaskTemplate(id)).payload.then(
      () => {
        dispatch(deleteTaskTemplateSuccess(id));
      },
      (error) => {
        dispatch(deleteTaskTemplateFailure(error.response?.data || error));
        throw error;
      }
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TaskTemplatesListContainer);
